import request from '@/utils/request'

/** 核心 KPI 概览 */
export function getOverview() {
  return request({
    url: '/manage/dashboard/overview',
    method: 'get'
  })
}

/** 近7天申领/核销趋势 */
export function getTrend() {
  return request({
    url: '/manage/dashboard/trend',
    method: 'get'
  })
}

/** 待办事项 */
export function getTodos() {
  return request({
    url: '/manage/dashboard/todos',
    method: 'get'
  })
}
